import { render, staticRenderFns } from "./CustomerTools.vue?vue&type=template&id=8de61bbe"
import script from "./CustomerTools.vue?vue&type=script&lang=js"
export * from "./CustomerTools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports